import { Get, Get2, GetCardInfo, GetMerchant, GetMplugin, Get3, Post, PostJuspay, PostMplugin, Put } from 'api';

import { API_URL, BASE_PATH_MERCHANT } from './CONSTANT';
import {
	IPaymentModesResponse,
	ISendPaymentModesResponse,
	IGenerateOtpResponse,
	IPaymentStatusResponse,
	ISampleResponse,
	rzpCardInfoResponse,
} from 'types';
import { globalId } from '../index';
import pjson from '../../package.json';
import { loadState } from 'utils/LocalStorage';
import { getURLParameter } from 'utils/nativeSupport';

// For Getting Payment Modes
export const GetPaymentModesDetail = async (id: any): Promise<IPaymentModesResponse> => {
	return Get<IPaymentModesResponse>(`${API_URL.payment_mode}${id}/method`);
};
// For Getting Payment Details - https://demo1154293.mockable.io/postPayment
export const SendPaymentModesDetail = async (payload: any): Promise<ISendPaymentModesResponse> => {
	return Post<ISendPaymentModesResponse>(`${API_URL.payment_mode}${globalId}/method`, { payload });
};
// For Getting JUSPAY Payment Modes V2
//2
export const GetJuspayPaymentModes = async (payload: any): Promise<ISampleResponse> => {
	const appInfoParsed: any = loadState('APP_INFO');
	const appversion = getURLParameter(window.location.href, 'appversion') || appInfoParsed?.appversion || '';
	const platformID = getURLParameter(window.location.href, 'platform') || appInfoParsed?.platform || '';
	const platform = platformID === '0' ? 'ANDROID' : 'IOS';

	return Get<ISampleResponse>(
		`${API_URL.getPaymentModesV3}${globalId}/method/${payload?.checkout}?appversion=${appversion}&platform=${platform}`,
	);
};

export const UpdateCheckoutType = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(`${API_URL.updateCheckoutType}${globalId}/checkout/${payload?.checkout}`, payload);
};

export const GetMandate = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(API_URL.getMandate, payload);
};

// For Getting JUSPAY Web Payment Modes V2
export const GetJuspayWebPaymentModes = async (payload: any): Promise<ISampleResponse> => {
	// const isDummyData = getURLParameter(window.location.href, 'isDummyData') || '';
	// if (isDummyData) {
	// 	return Get<ISampleResponse>('https://demo1154293.mockable.io/getPaymentModes');
	// }
	return Get<ISampleResponse>(`${API_URL.getPaymentModesV2}${globalId}/method/webview/${payload?.checkout}`);
};
// For doing FP mode txn and retrying with JUSPAY modes
export const PostJuspayFpAndOtherModes = async (payload: any): Promise<ISampleResponse> => {
	return PostJuspay<ISampleResponse>(
		`${API_URL.getPaymentModesV2}${globalId}/method/${payload?.checkout}`,
		payload?.request,
	);
};
// For Updating Cashback details JUSPAY
export const UpdateJuspayCashback = async (payload: any): Promise<ISampleResponse> => {
	return Post<ISampleResponse>(`${API_URL.getPaymentModesV2}${globalId}/update`, payload);
};
// Get Request for Payment Status Details
export const GetPaymentStatusDetails = async (id: string): Promise<IPaymentStatusResponse> =>
	Get<IPaymentStatusResponse>(`${API_URL.payment_status}${id}`);

// Generate Otp
export const GenerateOtpDetails = async (payload: any): Promise<IGenerateOtpResponse> => {
	return Post<IGenerateOtpResponse>(`${API_URL.verify_otp}`, { ...payload });
};

// Resend Otp
export const ResendOtpDetails = async (payload: any): Promise<IGenerateOtpResponse> => {
	return Post<IGenerateOtpResponse>(`${API_URL.resend_otp}`, { ...payload });
};

// For Getting Payment Details
export const CancelPaymentApi = async (payload: any): Promise<ISendPaymentModesResponse> => {
	return Post<ISendPaymentModesResponse>(`${API_URL.payment_mode}cancel`, { ...payload });
};

// Get Request for postpe cashback details
export const GetPostpeCashbackDetails = async (id: string): Promise<ISampleResponse> =>
	Get<ISampleResponse>(`${API_URL.get_cashback}?orderId=${id}`);

// For applying/unnapply postpe cashback
export const SendPostpeCashbackConfirmation = async (payload: any): Promise<ISampleResponse> => {
	return Put<ISampleResponse>(`${API_URL.toggle_postpe_cashback}`, { ...payload });
};

// Get Request for card info based on IIN
export const GetCardInfoFromIIN = async (iin: string | number): Promise<rzpCardInfoResponse> =>
	GetCardInfo<any>(`${API_URL.get_card_info}?iin=${iin}`);

export const GetMerchantInfoAPI = async (): Promise<ISampleResponse> =>
	GetMerchant<ISampleResponse>(BASE_PATH_MERCHANT + API_URL.merchantInfo);

export const GetSettlementAccount = async (): Promise<IPaymentStatusResponse> =>
	Get3<IPaymentStatusResponse>(`${API_URL.settlement_account}${globalId}/get-settlement-account`);

export const GetCustomerSettlementAccount = async (): Promise<IPaymentStatusResponse> =>
	Get3<IPaymentStatusResponse>(API_URL.customer_settlement_account);

export const GetAllTransaction = async (params: any): Promise<IPaymentStatusResponse> =>
	Get3<IPaymentStatusResponse>(`${API_URL.all_transactions}`, params);

export const GetUdirReasonCodes = async (): Promise<any> => GetMplugin<any>(API_URL.udir_reason_codes);

export const GetUdirComplaint = async (params: any): Promise<any> => GetMplugin<any>(API_URL.fetch_comaplaint + params);

export const GetAllUdirComplaint = async (params: any): Promise<any> =>
	GetMplugin<any>(API_URL.all_fetch_comaplaint + params);

export const RegisterComplaint = async (params: any): Promise<any> =>
	PostMplugin<any>(API_URL.register_complaint, params);

export const GetUPIUserDetails = async (): Promise<any> => Get3<any>(API_URL.user_upi_details);

export const ValidateSettlementAccount = async (params: any): Promise<any> =>
	PostMplugin<any>(API_URL.validate_settlement_account, params);

export const CreateUPIAccount = async (params: any): Promise<any> => PostMplugin<any>(API_URL.create_user, params);

export const SyncBank = async (payload: any): Promise<ISampleResponse> => {
	return Put<ISampleResponse>(`${API_URL.user_upi_details}`, { ...payload });
};

export const FetchLanguageFile = async (url: string): Promise<Record<string, string>> =>
	Get2<any>(`${window.location.origin}${url}?v=${pjson.version}`);
